import { MonitoringDate } from 'api';
import { NextDateLabel } from './NextDateLabel';

export const NextMonitoringDateLabel = ({ date }: { date?: MonitoringDate }) => {
  const value = date?.text ?? date?.calculatedDate;

  if (!value || date?.text === 'Blank') {
    return null;
  }

  return <NextDateLabel label="Next monitoring date" value={value} />;
};
